import { observable, action, reaction } from 'mobx';
import { localStorage } from 'utils/helpers';

class AppSession {
  @observable token = localStorage.getItem('jwt');
  @observable loaded;

  constructor() {
    reaction(
      () => this.token,
      (token) => {
        if (token) {
          localStorage.setItem('jwt', token);
        } else {
          localStorage.removeItem('jwt');
        }
      }
    );
  }

  @action
  setToken(token) {
    this.token = token;
  }

  @action
  setLoaded() {
    this.loaded = true;
  }

  @action
  reset() {
    this.token = null;
    this.loaded = null;
    delete window.me;
  }

  isLoggedIn() {
    return !!this.token;
  }
}

export default new AppSession();
